module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-bread-crumb', {
    attrs: {
      "bread-cumb": _vm.breadCrumb
    }
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "70px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动名称"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.form.activity_name))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动店铺"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.form.shop_name))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动简介"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.form.brief))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动时间"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.form.begin_time) + " 至 " + _vm._s(_vm.form.end_time))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动介绍"
    }
  }, [_c('div', {
    staticClass: "ql-editor",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.form.intro)
    }
  })])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动人数"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.form.join_num) + " / " + _vm._s(_vm.form.number))])])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('preview', {
    attrs: {
      "data": _vm.form.intro
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fdb37fb2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/views/activity/activityDetail.vue
// module id = 953
// module chunks = 0